export default __webpack_public_path__ + "images/b08e46e605875a1c522b2ce4afdd49fb-supporting_individuals_with_mental_health_needs.svg";